export default "__VITE_ASSET__Hxdn9qC$__"